import { ReactComponent as CheckMark } from '../../../../assets/shared/ic-shared-small-success.svg';
import { twMerge } from 'tailwind-merge';
import Highlighter from 'react-highlight-words';
import { FontWeight, Heading, useFontClass } from '../../../tokens';

export type LiliComboboxWithInputValueConstraint = string | number;
export interface MenuItem<T extends LiliComboboxWithInputValueConstraint> {
  title: string;
  value: T;
  itemDescription?: string;
  prefix?: string;
}
// TODO: Add className to the component FIX
interface SelectMenuItemProps<T extends LiliComboboxWithInputValueConstraint> {
  id: string;
  item: MenuItem<T>;
  isSelected: boolean;
  searchWord?: string;
  onClick: (value: T) => void;
}
export const SelectMenuItem = <T extends LiliComboboxWithInputValueConstraint>({
  id,
  item,
  isSelected,
  searchWord,
  onClick,
}: SelectMenuItemProps<T>) => {
  const { fontClass } = useFontClass();
  return (
    <button
      translate='no'
      id={`${id}-select-menu-item-${item.value}`}
      className='w-full px-[8px] py-[4px] flex items-center rounded-[6px] justify-between h-[50px]'
      onClick={(event) => {
        event.stopPropagation();
        onClick(item.value);
      }}
      type='button'>
      <div
        className={twMerge(
          'flex items-center w-full h-full pl-[8px] pr-[6px] py-[6px] justify-between',
          isSelected && 'bg-surface-brand-action-00 rounded-[8px]',
          !isSelected && 'hover:bg-surface-primary-bw-02 rounded-[8px]'
        )}>
        <span className='flex items-center justify-between'>
          <span className='text-[32px] mr-[8px]'>{item.title}</span>
          {item.prefix && (
            <span className='flex items-center gap-[4px] mr-[4px]'>
              <Heading.H9 fontWeight={FontWeight.SEMIBOLD} className={`${fontClass}`}>
                <Highlighter
                  highlightClassName='text-text-brand-primary'
                  searchWords={[searchWord || '']}
                  autoEscape={true}
                  textToHighlight={item.prefix}
                  highlightTag='span'
                />
              </Heading.H9>
              <span> - </span>
            </span>
          )}
          <Heading.H9 className={`text-start ${fontClass}`}>
            <Highlighter
              highlightClassName='text-text-brand-primary'
              searchWords={[searchWord || '']}
              autoEscape={true}
              textToHighlight={item.itemDescription || item.title}
              highlightTag='span'
            />
          </Heading.H9>
        </span>
        {isSelected && <CheckMark className='text-text-brand-primary' />}
      </div>
    </button>
  );
};
